export enum BillingMode {
  onDemand = "on-demand",
  standardEdition = "standard-edition",
  enterpriseEdition = "enterprise-edition",
  enterprisePlusEdition = "enterprise-plus-edition",
}
